<template>
  <v-container class="px-sm-8 py-0 pa-md-0 mb-12">
      <v-row no-gutters align="start" justify="start">
        <v-col cols="12" md="4" v-click-outside="handleClose">      
          <button @click="isSelected = !isSelected">
            <div class="anchor-current">
              <span class="text-nav-anchor mb-0 text--fes-blue">{{ currentChapter }}</span>
              <img v-show="isSelected" src="@/assets/dropdown-chevron-up.svg" class="mx-4" />
              <img v-show="!isSelected" src="@/assets/dropdown-chevron-down.svg" class="mx-4" />  
            </div>            
          </button>
          <transition name="block">
            <ul class="list" v-show="isSelected">
              <li v-for="n in chapterList" :key="n.id + '-solutions'" class="text-nav-anchor text--fes-blue" @click="jumpChapter(n.id)">{{ n.label }}</li>
            </ul>
          </transition>
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SolutionsAnchorNav",
  props: {
    section: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      chapters: [
        { id: 1, label: "Introduction to Models" },
        { id: 2, label: "Applications of Social-Ecological Transformation" },
        { id: 3, label: "Three Core Principles" },
        { id: 4, label: "About FES" },
      ],
      isSelected: false,
    };
  },
  computed: {
    currentChapter() {
      return this.chapters[this.section - 1].label
    },
    chapterList() {
      const filtered = this.chapters.filter(chapter => {
          return chapter.id !== this.section
      })
      return filtered;
    },    
  },
  methods: {
    jumpChapter(chapterNo) {
      this.isSelected = !this.isSelected      
      const chapter = document.querySelectorAll(`.solutions-chapter-${chapterNo}`)[0];
      chapter.scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
    },
    handleClose() {
      this.isSelected ? this.isSelected = false : '';
    }    
  }  
}
</script>

<style lang="scss" scoped>
button{
  padding: 12px 0;
  border-right: 1px solid #235592;
  text-align: left;
  width: 100%;

  .anchor-current {
    display: flex; 
    justify-content: space-between;
    align-items: center;
  }
}

.list{
  width: 100%;
  margin: 0;
  padding: 12px 0;
  list-style-type: none;
  transform-origin: top;
  border-right: 1px solid #235592;

  li{
    margin-bottom: 16px;
    margin-right: 48px;
    opacity: 0.75;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
      opacity: 1;
    }

    &:last-child {
      margin-bottom: 0;
    }    
  }
}

.block-enter {
  opacity: 0;
  max-height: 350px;
  transform: scaleY(0);
}

.block-enter-active {
  animation: slide-in 0.3s ease-out forwards;
}

.block-leave {
  opacity: 1;
  max-height: 0;
  overflow: hidden;
  transform: scaleY(0);
}

.block-leave-active {
  animation: slide-out 0.3s ease-out forwards;
}

@keyframes slide-in {
  from {
    max-height: 0;
    transform: scaleY(0);
    opacity: 0;
  }
  to {
    max-height: 350px;
    transform: scaleY(100%);

    opacity: 1;
  }
}

@keyframes slide-out {
  from {
    max-height: 350px;
    transform: scaleY(100%);
    opacity: 1;
  }
  to {
    max-height: 0;
    transform: scaleY(0);
    opacity: 0;
  }
}
</style>